import { GRID_FILTERS_ADD, GRID_FILTERS_UPDATE, GRID_FILTERS_CLEAR } from '../constants/types';

function addGridFilters(state) {
  return {
    type: GRID_FILTERS_ADD,
    state,
  };
}

function updateGridFilters(state) {
  return {
    type: GRID_FILTERS_UPDATE,
    state,
  };
}

function clearGridFilters(state) {
  return {
    type: GRID_FILTERS_CLEAR,
    state,
  };
}

export { addGridFilters, updateGridFilters, clearGridFilters };
